<template>
    <div>
        <div v-if="$vuetify.breakpoint.mdAndUp" class="sidebar-container">
            <transition name="draw">
                <v-col v-if="isSidebarOpen" class="sidebar">
                    <v-expansion-panels style="padding-left: 11px !important;">
                        <TitlePanel
                            v-show="relatedObject"
                            class="title-panel"
                            :related-type="relatedType"
                            :related-object="relatedObject"
                            @closeSidebar="toggleSideBar(false)"
                            @navigateToEdit="navigateToEdit"
                        />
                    </v-expansion-panels>
                    <SidebarContent
                        :related-type="relatedType"
                        :sub-type="subType"
                        style="padding-left: 11px !important;"
                        class="sidebar-content-container"
                        @relatedObject="setRelatedObject"
                    />
                </v-col>
            </transition>
            <div v-if="!isSidebarOpen" class="open-button-container">
                <v-tooltip bottom>
                    <template v-slot:activator="{ on: tooltipOn }">
                        <v-chip
                            v-on="tooltipOn"
                            medium
                            color="white"
                            class="sidebar-button sidebar-button--open"
                            @click="toggleSideBar(true)"
                        >
                            <icon
                                style="margin-left: 6px"
                                color="g4"
                                icon="PanelRightOpen"
                            />
                        </v-chip>
                    </template>
                    <span>{{ $t("Expand sidebar") }}</span>
                </v-tooltip>
            </div>
        </div>
    </div>
</template>

<script>
import AppModule from "../store/modules/app";
import SidebarContent from "./Sidebar/SidebarContent.vue";
import {$t} from "../i18n";
import TitlePanel from "./Sidebar/TitlePanel.vue";
import {ref} from "@vue/composition-api";
import {relatedTypeEnum} from "./Sidebar/sidebar";
import {actions as clientModule} from "../store/modules/client";
import router from "../router";

export default {
    name: "Sidebar",
    methods: {$t},
    components: {TitlePanel, SidebarContent},
    props: {
        relatedType: {
            type: String,
        },
        subType: {
            type: String,
            defualt: null
        },
        isSidebarOpen: {
            type: Boolean,
            default: false,
        }
    },
    setup(props) {
        const {toggleSideBar} = AppModule();
        const relatedObject = ref(null)

        const setRelatedObject = (value) => {
            relatedObject.value = value
        }

        const navigateToEdit = () => {
            if (props.relatedType === relatedTypeEnum.CLIENT) {
                clientModule.navigateToClientEdit()
            } else if (props.relatedType === relatedTypeEnum.PROJECT) {
                router.push({
                    name: "project_edit",
                    params: {id: relatedObject.value.id},
                });
            }
        }

        return {
            toggleSideBar,
            setRelatedObject,
            relatedObject,
            navigateToEdit
        };
    }
};
</script>

<style scoped lang="scss">
.sidebar-container {
    position: fixed;
    right: 0;
    top: 56px;
    bottom: 0;
    max-height: calc(100vh - 56px);

    &:hover .close-button-container {
        visibility: visible;
    }

    &:hover {
        .sidebar-button--closed {
            visibility: visible;
        }
    }
}

.sidebar {
    width: 382px;
    height: 100%;
    max-width: 382px;
    position: relative;
    left: 0;
    opacity: 1;
    padding-top: 8px;
    padding-left: 0 !important;
    padding-right: 1px !important;
    padding-bottom: 0;
    display: flex;
    flex-direction: column;
}

.draw-enter-active,
.draw-leave-active {
    transition: left 0.2s ease-in-out, opacity 0.2s ease-in-out;
}

.draw-enter,
.draw-leave-to {
    left: 382px;
    opacity: 0;
}

.close-button-container {
    margin: 0;
    position: relative;
    left: -24px;
    visibility: hidden;
    display: inline;
}

.open-button-container {
    position: absolute;
    top: 0;
    left: -20px;

    .sidebar-button {
        min-width: 100px;
    }
}

.sidebar-button {
    padding: 0;
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.1);
    position: absolute;
    left: -12px;
    top: 18px;
    z-index: 1;
    height: 34px !important;

    &--open {
        width: 100px;
    }

    &--closed {
        display: flex;
        justify-content: center;
        visibility: hidden;
    }
}

.draw-leave-active + .open-button-container {
    display: none;
}

.v-expansion-panel::before {
    display: none;
}

.title-panel {
    position: sticky;
    top: 0;
    z-index: 10;
    margin-bottom: 1px;
}

.sidebar-content-container {
    z-index: 11;
    overflow-y: auto;
    flex-grow: 0;
    padding-right: 1px !important;
    padding-bottom: 11px;
}
</style>
